<template>
    <div class="serverPdf">
		<img @click="preview(0)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/1.jpg">
        <img @click="preview(1)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/2.jpg">
        <img @click="preview(2)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/3.jpg">
        <img @click="preview(3)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/4.jpg">
        <img @click="preview(4)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/5.jpg">
        <img @click="preview(5)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/6.jpg">
        <img @click="preview(6)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/7.jpg">
        <img @click="preview(7)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/8.jpg">
        <img @click="preview(8)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/9.jpg">
        <img @click="preview(9)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/10.jpg">
        <img @click="preview(10)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/11.jpg">
        <img @click="preview(11)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/12.jpg">
        <img @click="preview(12)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/13.jpg">
        <img @click="preview(13)" src="https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/14.jpg">
    </div>
</template>

<script>
import { contents } from './util';
import { ImagePreview } from 'vant';
import { weixinInit } from '@/utils/wechatUtil.js';
import { selUserPrivilegeDetail  } from '@/api';
export default {
    data() {
        return {
           personName: '',
           idCardNo: '',
           activationCardNumber: '',
           personPhone: '',
           personPrivilegeId: '',
        }
    },
    created() {
    },
    methods: {
        async preview(index) {
            ImagePreview({
            images:[
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/1.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/2.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/3.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/4.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/5.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/6.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/7.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/8.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/9.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/10.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/11.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/12.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/13.jpg',
                'https://more-health.oss-cn-beijing.aliyuncs.com/208/Pictures/14.jpg'
            ],
            startPosition: index,
            closeable: true,
        });
        },
        async init() {
            try {
                const res = await selUserPrivilegeDetail({
                    personPrivilegeId: this.personPrivilegeId
                });
                if (res.code == 200) {
                    this.personName = res.data[0].personName;
                    this.idCardNo = res.data[0].credentialsNumber;
                    this.activationCardNumber = res.data[0].activationCardNumber;
                    this.personPhone = res.data[0].personPhone;
                } else if (res.code == 2014) {
                    // 无权益
                    this.rightsVisable = false;
                }
            } catch(err) {
                console.log('err', err);
            }
        }
    }
}
</script>
<style scoped lang="less">
.serverPdf {
    width: 100%;
    margin: 0;
    img {
        width: 100%;
    }
}
.divText {
    margin-left: 25px;
    width: 330px;
    font-size: 10px;
    line-height: 20px;
}
</style>